import React from 'react'
import PropTypes from 'prop-types'
import { ListGrid } from '@maui/elements'
import { Details, Term, Definition } from '../../common/Details'
import { InfoTooltip } from '../../common/Tooltip'
import Freemium from '../../common/Freemium/Freemium'
import { DetailsSection } from '../DetailsSection'

export const MalwareSummary = ({ malware, ...detailsSectionProps }) => {
  const {
    description,
    aliases,
    isMalicious
  } = malware || {}

  const title = isMalicious ? 'Malware Summary' : 'Tool Summary'

  return (
    <DetailsSection title={title} {...detailsSectionProps}>
      <Details>
        <Term>Description</Term>
        <Definition>{description}</Definition>
        {!!aliases?.length &&
          <>
            <Term>
              Reported As
              <InfoTooltip tooltip='Associated indicators have also been reported by organizations under the following names' />
            </Term>
            <Definition>
              {aliases && Array.isArray(aliases) &&
                <ListGrid list={aliases}>
                  {item => item.name}
                </ListGrid>
              }
              {aliases === 'redacted' &&
                <Freemium layout="fullCenter" />
              }
            </Definition>
          </>
        }
      </Details>
    </DetailsSection>
  )
}

MalwareSummary.propTypes = {
  malware: PropTypes.object
}
